import { render, staticRenderFns } from "./SearchbarECommerce.vue?vue&type=template&id=2f8f63eb&"
import script from "./SearchbarECommerce.vue?vue&type=script&lang=js&"
export * from "./SearchbarECommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports